import http from "./http";

export default {
  show(id) {
    return http.plainAxiosInstance.get(`/matches/${id}`);
  },

  delete(id) {
    return http.plainAxiosInstance.delete(`/matches/${id}`);
  }
};
